export default "__VITE_ASSET__656abda1__"